import React from "react";
import CancelPopup from "./CancelPopup";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/deleteIcon.svg";

/**
 * Reusable Delete Confirmation Modal Component
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onClose - Callback to close the modal
 * @param {function} onConfirm - Callback when delete is confirmed
 * @param {string} itemName - Name of the item being deleted (e.g., "Merchant", "Fundraiser")
 * @param {string} customMessage - Optional custom message (falls back to default)
 */
const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName = "Item",
  customMessage
}) => {
  if (!isOpen) return null;

  const defaultMessage = `Are you sure you want to delete this ${itemName.toLowerCase()} profile? This action cannot be undone.`;

  return (
    <CancelPopup
      handleNo={onClose}
      handleYes={onConfirm}
      heading={`Delete ${itemName}`}
      content={customMessage || defaultMessage}
      icon={<DeleteIcon className="text-[#EE5353] stroke-current" />}
      confirmation={false}
      popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
    />
  );
};

export default DeleteConfirmationModal;
